import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  holiday: [],
  holidayTypes: []
}

export const mutations = {
  SET_HOLIDAY(state, holiday) {
    state.holiday = holiday
  },
  SET_HOLIDAY_TYPES(state, holidayTypes) {
    state.holidayTypes = holidayTypes
  },
  ADD_HOLIDAY(state, holiday) {
    state.holiday.push(holiday)
  },
  EDIT_HOLIDAY(state, holiday) {
    const index = state.holiday.findIndex(
      element => element.holiday_uuid === holiday.holiday_uuid
    )
    if (index !== -1) {
      state.holiday.splice(index, 1, holiday)
    }
  },
  DELETE_HOLIDAY(state, holiday_uuid) {
    const index = state.holiday.findIndex(
      element => element.holiday_uuid === holiday_uuid
    )
    if (index !== -1) state.holiday.splice(index, 1)
  }
}

export const actions = {
  fetchHoliday({ commit }, payload) {
    return ApiService.fetchHoliday(payload)
      .then(res => {
        const holiday = res.data.data
        commit('SET_HOLIDAY', holiday)
      })
      .catch(error => {
        throw error
      })
  },
  fetchHolidayTypes({ commit }) {
    return ApiService.fetchHolidayTypes()
      .then(res => {
        const holidayTypes = res.data.data
        commit('SET_HOLIDAY_TYPES', holidayTypes)
      })
      .catch(error => {
        throw error
      })
  },
  addHoliday({ commit }, payload) {
    return ApiService.addHoliday(payload)
      .then(res => {
        const holiday = res.data
        commit('ADD_HOLIDAY', holiday)
      })
      .catch(error => {
        throw error
      })
  },
  editHoliday({ commit }, payload) {
    return ApiService.editHoliday(payload)
      .then(res => {
        const holiday = res.data
        commit('EDIT_HOLIDAY', holiday)
      })
      .catch(error => {
        throw error
      })
  },
  deleteHoliday({ commit }, payload) {
    return ApiService.deleteHoliday(payload)
      .then(() => {
        commit('DELETE_HOLIDAY', payload.holiday_uuid)
      })
      .catch(error => {
        throw error
      })
  }
}
